
import { ReactNode } from "react";
import { TourProvider, useTour } from "@reactour/tour";
import { NavigationComponent } from "./renderer";

export const TourWrapper = ({ children }: { children: ReactNode }) => {

  return (
    <TourProvider
        maskClassName="maskWrapper"
        steps={[]}
        showBadge={false}
        showCloseButton={false}
        disableInteraction={true}
        onClickMask={() => {  }}
        components={{
          Navigation: NavigationComponent,
        }}
        styles={{
          maskWrapper: (base) => ({
            ...base,
            pointerEvents:"none"
          }),
          popover: (base) => ({
            ...base,
            position: "fixed",
            padding: "1.25rem",
            right: "24px",
            bottom: "24px",
            width: "23.5rem",
            top: "auto",
            left: "auto",
            transform: "none",
            maxWidth: "none",
            borderRadius: "1.5rem",
            boxShadow: "0 10px 40px rgba(0,0,0,0.15)",
            pointerEvents: "auto"
          }),
        }}
      >
        {children}
      </TourProvider>
  )
}
